<template>
    <div>
        <b-button variant="outline-light" v-on:click="getDetay()" size="sm">
            <Icon icon="icon-park-outline:find" width="25" height="25" v-b-tooltip.hover.bottom="'Marketplace Stok Bul'" color="#28C76F" />
        </b-button>
    </div>
</template>
<script>
import { Icon } from "@iconify/vue2";
export default {
    components: {
        Icon
    },
    methods: {
        getDetay() {
            this.$root.$emit("getStokListMarketplace", this.params.data);
        }
    }
};
</script>
  